var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 480,
    viewBox: "0 0 1920 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5337",
    "data-name": "Caminho 5337",
    d: "M0,0H1920V480H0Z",
    transform: "translate(0 189)",
    fill: "#633f88"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "figure",
    transform: "translate(0 -189)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2791",
    "data-name": "Grupo 2791",
    transform: "translate(1016.008 48.091)",
    opacity: 0.133
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5292",
    "data-name": "Caminho 5292",
    d: "M455.639,482.476q0,46.033.026,92.065a7.135,7.135,0,0,0,.664,3.5,2.5,2.5,0,0,0,4.468-.728c1.245-6.345,6.388-7.467,11.221-8.082a154.873,154.873,0,0,1,19.913-.877c16.875.046,33.752.567,50.624.422,12.761-.109,25.532-.868,37.766-5.136,5.7-1.988,11.085-4.549,15.5-8.839a6.873,6.873,0,0,0,2.254-5.294q-.065-91.4-.1-182.8c0-1.346-.568-3.257-1.54-3.909-1.618-1.088-2.994.394-4.214,1.638-5.609,5.721-12.85,8.4-20.4,9.841a147.366,147.366,0,0,1-23.053,2.752c-13.87.423-27.763.156-41.647.063-7.879-.053-15.773-.7-23.634-.388a97.178,97.178,0,0,0-17.686,2.568c-2.65.606-5.075,2.624-7.344,4.343-2.134,1.618-2.859,4.032-2.856,6.8Q455.685,436.444,455.639,482.476Z",
    transform: "translate(-10.237 -7.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5293",
    "data-name": "Caminho 5293",
    d: "M442.6,190.194s-170.259-9.9-173.22,192.113",
    transform: "translate(-2.22 0)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 21.107
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5294",
    "data-name": "Caminho 5294",
    d: "M447.553,190.194s170.259-9.9,173.22,192.113",
    transform: "translate(-9.89 0)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 21.107
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5295",
    "data-name": "Caminho 5295",
    d: "M239.659,416.833c0-18.326,7.72-33.288,17.484-34.512V382.2h21.666v69.266H257.143v-.12C247.379,450.121,239.659,435.159,239.659,416.833Z",
    transform: "translate(-0.941 -8.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9056",
    "data-name": "Ret\\xE2ngulo 9056",
    width: 13.86,
    height: 33.107,
    rx: 1.302,
    transform: "translate(217.804 393.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9057",
    "data-name": "Ret\\xE2ngulo 9057",
    width: 13.86,
    height: 33.107,
    rx: 1.302,
    transform: "translate(645.306 393.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5296",
    "data-name": "Caminho 5296",
    d: "M655.258,416.833c0-18.326-7.72-33.288-17.484-34.512V382.2H616.108v69.266h21.666v-.12C647.538,450.121,655.258,435.159,655.258,416.833Z",
    transform: "translate(-17.146 -8.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5297",
    "data-name": "Caminho 5297",
    d: "M436.118,390.411c0-2.764-.721-5.177-2.856-6.8-2.269-1.719-4.694-3.737-7.343-4.343a97.189,97.189,0,0,0-17.687-2.568c-7.859-.313-15.753.335-23.634.388-13.882.093-27.777.359-41.646-.063a147.339,147.339,0,0,1-23.053-2.752c-7.55-1.443-14.791-4.121-20.4-9.841-1.219-1.244-2.6-2.726-4.214-1.638-.97.652-1.538,2.563-1.54,3.909q-.109,91.4-.1,182.8A6.87,6.87,0,0,0,295.9,554.8c4.415,4.289,9.8,6.851,15.5,8.839,12.235,4.268,25.006,5.027,37.767,5.136,16.872.144,33.748-.376,50.624-.422a154.865,154.865,0,0,1,19.912.877c4.834.614,9.977,1.737,11.221,8.082a2.5,2.5,0,0,0,4.468.728,7.147,7.147,0,0,0,.665-3.5q.05-46.033.025-92.065Q436.086,436.444,436.118,390.411ZM320.051,536.133a3.28,3.28,0,1,1,1.019-2.376A3.251,3.251,0,0,1,320.051,536.133Zm0-10.41a3.278,3.278,0,1,1,1.019-2.376A3.259,3.259,0,0,1,320.051,525.723Zm0-35.939a3.278,3.278,0,1,1,1.019-2.376A3.252,3.252,0,0,1,320.051,489.784Zm0-20.818a3.283,3.283,0,1,1,1.019-2.379A3.26,3.26,0,0,1,320.051,468.965Zm0-46.349a3.282,3.282,0,1,1,1.019-2.378A3.256,3.256,0,0,1,320.051,422.616Zm10.412,103.107a3.282,3.282,0,1,1,1.017-2.376A3.265,3.265,0,0,1,330.463,525.723Zm0-10.41a3.286,3.286,0,1,1,1.017-2.378A3.262,3.262,0,0,1,330.463,515.313Zm0-35.939A3.283,3.283,0,1,1,331.48,477,3.266,3.266,0,0,1,330.463,479.374Zm0-10.409a3.287,3.287,0,1,1,1.017-2.379A3.266,3.266,0,0,1,330.463,468.965Zm0-35.939a3.284,3.284,0,1,1,1.017-2.376A3.268,3.268,0,0,1,330.463,433.026Zm0-10.41a3.286,3.286,0,1,1,1.017-2.378A3.263,3.263,0,0,1,330.463,422.616Zm17.5,92.7a3.279,3.279,0,1,1,1.02-2.378A3.254,3.254,0,0,1,347.964,515.313Zm0-46.348a3.281,3.281,0,1,1,1.02-2.379A3.258,3.258,0,0,1,347.964,468.965Zm0-25.531a3.276,3.276,0,1,1,1.02-2.375A3.247,3.247,0,0,1,347.964,443.435Zm0-20.818a3.28,3.28,0,1,1,1.02-2.378A3.255,3.255,0,0,1,347.964,422.616Zm10.412,103.107a3.282,3.282,0,1,1,1.017-2.376A3.263,3.263,0,0,1,358.375,525.723Zm0-92.7a3.284,3.284,0,1,1,1.017-2.376A3.266,3.266,0,0,1,358.375,433.026Zm17.5,82.287a3.279,3.279,0,1,1,1.02-2.378A3.253,3.253,0,0,1,375.874,515.313Zm0-71.879a3.276,3.276,0,1,1,1.02-2.375A3.245,3.245,0,0,1,375.874,443.435Zm0-10.409a3.277,3.277,0,1,1,1.02-2.376A3.259,3.259,0,0,1,375.874,433.026Zm0-10.41a3.28,3.28,0,1,1,1.02-2.378A3.253,3.253,0,0,1,375.874,422.616Zm10.412,92.7a3.286,3.286,0,1,1,1.017-2.378A3.26,3.26,0,0,1,386.286,515.313Zm0-82.287a3.284,3.284,0,1,1,1.017-2.376A3.266,3.266,0,0,1,386.286,433.026Zm17.5,82.287a3.281,3.281,0,1,1,1.019-2.378A3.256,3.256,0,0,1,403.787,515.313Zm0-82.287a3.279,3.279,0,1,1,1.019-2.376A3.262,3.262,0,0,1,403.787,433.026Zm10.412-10.41a3.286,3.286,0,1,1,1.017-2.378A3.262,3.262,0,0,1,414.2,422.616Z",
    transform: "translate(-3.265 -7.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2659",
    "data-name": "Grupo 2659",
    transform: "translate(340.84 232.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5298",
    "data-name": "Caminho 5298",
    d: "M373.146,298.531a31.79,31.79,0,0,1,62.313,1.071,32.257,32.257,0,0,1,14.613,0,31.789,31.789,0,0,1,62.34-.94l16.317-10.434a95.872,95.872,0,0,0-171.9-.049Z",
    transform: "translate(-346.825 -234.803)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5299",
    "data-name": "Caminho 5299",
    d: "M531.858,299.276l-19.389,12.4a31.784,31.784,0,0,1-63.313-1.7,32.255,32.255,0,0,0-13.683,0,31.785,31.785,0,0,1-63.339,1.477l-19.241-12.3.01-.39a95.756,95.756,0,0,0-2.275,62.968c13.679.317,27.377.084,41.066,0,8.3-.053,16.611-.7,24.888-.388a107.426,107.426,0,0,1,18.625,2.568c2.789.606,5.343,2.624,7.732,4.343a7.392,7.392,0,0,1,2.975,5.882,7.438,7.438,0,0,1,2.921-5.882c2.346-1.719,4.852-3.737,7.591-4.343a103.637,103.637,0,0,1,18.284-2.568c8.125-.313,16.285.335,24.432.388,11.609.075,23.224.257,34.829.1a95.758,95.758,0,0,0-2.114-62.727Z",
    transform: "translate(-346.375 -237.556)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBanner);
export default __webpack_public_path__ + "static/media/logo-banner.6496bd445502d0399958436fdac3e4bb.svg";
export { ForwardRef as ReactComponent };